import React, { useRef } from 'react';
import './Bookings.css'
import emailjs from '@emailjs/browser';

function Bookings({
  title = 'Contact Kushim',
  intro = 'Share your thoughts, questions, or booking request below.',
  messageLabel = 'Message:',
  buttonText = 'Send',
  messagePlaceholder = 'Type your message here...'
}) {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    const name = form.current?.elements.user_name?.value?.trim() || '';
    const email = form.current?.elements.user_email?.value?.trim() || '';
    const message = form.current?.elements.message?.value?.trim() || '';

    if (!name || !email) {
      alert("Please enter your name and email before sending.");
      return;
    }

    if (message === '') {
      alert("[Error]: Can’t Send With Empty Field, Type in Your Message and Try Again! :)");
      return;
    }

    emailjs.sendForm('service_90nx5bo', 'template_rjbabkq', form.current, 'xfMFLdkaSfYS41jgk')
      .then((result) => {
        alert("Message sent successfully! Thank You For Reaching Out!");
        console.log(result.text);
        form.current.reset();
      }, (error) => {
        console.log(error.text);
      });
  };

  return (
    <div> 
         {/*Contact Form*/}
        <div className='contactSection'>
        <span style={{marginBottom: '0.3rem'}}>{title}</span>
        <p className='contactIntro'>{intro}</p>
          <form ref={form} onSubmit={sendEmail} className='contactForm' id='messageForm'>
          <label>Name:</label>
          <input type="text" name="user_name" style={{backgroundColor: '#dae3c1', borderColor: '#000', marginBottom: '1rem', fontFamily:'sans-serif', fontSize: '15px'}}/>
          <label>Email:</label>
          <input type="email" name="user_email" style={{backgroundColor: '#dae3c1', borderColor: '#000', marginBottom: '1rem', fontFamily:'sans-serif', fontSize: '15px'}}/>
          <label>{messageLabel}</label>
          <textarea id='messageField' name="message" placeholder={messagePlaceholder} style={{backgroundColor: '#dae3c1', borderColor: '#000', borderRadius: '3px', flexDirection: 'row', resize:'none', marginBottom: '1rem', paddingBottom: '7rem', fontFamily:'sans-serif', fontSize: '15px'}}/>
          <input type="submit" value={buttonText} 
          style={{color: 'black', display: 'flex', alignSelf: 'center'}}/>
          </form>

        </div>
    </div>

  )
}

export default Bookings